export const getApiUrl = () =>
  (window._env_ && window._env_.API_URL) || process.env.REACT_APP_API_URL || '';
